export enum WebsocketAction {
  StyleStudioLeave = 'STYLE_STUDIO_LEAVE',
  StyleStudioLeaveConfirmed = 'STYLE_STUDIO_LEAVE_CONFIRM',
  DownloadGoldenTicket = 'DOWNLOAD_GOLDEN_TICKET',
  OpenIconsGuide = 'OPEN_ICONS_GUIDE',
  CrowningMoment = 'CROWNING_MOMENT',
  CloseMagicMirror = 'MAGIC_MIRROR_CLOSE',
  EventProfileStateUpdated = 'EVENT_PROFILE_STATE_UPDATED',
  SaveCMAvatar = 'SAVE_CM_AVATAR',
  CmAvatarProcessed = 'CM_AVATAR_PRECESSED',
  EnteringSSExperience = 'ENTERING_SS_EXPERIENCE',
}

export enum ChangeAvatarTypes {
  UniformTryOn = 'UNIFORM_TRY_ON',
  Unfinished = 'UNFINISHED',
  MagicMirror = 'MAGIC_MIRROR',
  CrowningMoment = 'CROWNING_MOMENT',
  UniformHalf = 'UNIFORM_HALF',
  UniformFull = 'UNIFORM_FULL',
  UniformFullSubsequent = 'UNIFORM_FULL_SUBSEQUENT',
}

export enum IXRHrBrandTypes {
  Dnata = 'DNATA', // Uniformed
  Marhaba = 'MARHABA', // Uniformed
  Ekas = 'EMIRATES - EKAS', // Uniformed
  CC = 'EMIRATES - CONTACT CENTRE', // Non Uniformed
  HR = 'HR FACILITATOR', // Non Uniformed
  SD = 'EMIRATES - SERVICE DELIVERY', // Uniformed
}

export const IXR_HR_BRAND_UNIFORMS = ['DNATA', 'MARHABA', 'EMIRATES - EKAS'];

export enum IXRHrCredStatusTypes {
  Pre = 'ADVISE TO RESIGN',
  FT = 'FULL TIME EMPLOYEE',
}

export enum IXRHrGenderTypes {
  M = 'M',
  F = 'F',
}

export enum IXRHrPersonaTypes {
  CSA = 'CSA', // HR
  HR_Facilitator = 'HR FACILITATOR', // HR
  CabinCrew = 'CABIN CREW', // SD
  Abinitio = 'AB INITIO', // SD
  Purser = 'PURSER', // SD
}

export enum IXRHrGradeCode {
  CC_01 = 'CC.01',
  CC_02 = 'CC.02',
  CC_03 = 'CC.03',
  CC_04 = 'CC.04',
  CC_05 = 'CC.05',
  CC_06 = 'CC.06',
}

export interface IiXRHrData {
  staffId: string;
  batchId: number;
  brand: string;
  ekCreatedDate: string;
  ekUpdateDate: string;
  gender: string;
  hrFacilitatorStaffId: string;
  ixrCredentialStatus: string;
  jobTitle: string;
  joiningDate: string;
  localHire: boolean;
  name: string;
  nickName: string;
  persona: string;
  personalEmail: string;
  preferredName: string;
  homeCountry: string;
  gradeCode?: IXRHrGradeCode;
}
